// @flow
import {
  fetchGradProgram as apiFetchGradProgram,
  hideGradProgram as apiHideGradProgram,
  unhideGradProgram as apiUnhideGradProgram
} from 'api/orgAdmin';
import type { GradProgram } from 'api/orgAdmin';
import type { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { clearResults } from '../mainSearch';

type FetchGradProgramRequestAction = {
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST',
  orgId: string
};
type FetchGradProgramSuccessAction = {
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS',
  orgId: string,
  gradProgram: GradProgram
};
type ResetGradProgramAction = { type: 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS' };

export type Action =
  | FetchGradProgramRequestAction
  | FetchGradProgramSuccessAction
  | ResetGradProgramAction;

const fetchGradProgramRequest = (
  orgId: string
): FetchGradProgramRequestAction => ({
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_REQUEST',
  orgId
});

const fetchGradProgramSuccess = (
  orgId: string,
  gradProgram: GradProgram
): FetchGradProgramSuccessAction => ({
  type: 'ORG_DASHBOARD_FETCH_GRAD_PROGRAM_SUCCESS',
  orgId,
  gradProgram
});

export const fetchGradProgram = (orgId: string, force: boolean = false) => (
  dispatch: Dispatch,
  getState: GetState
): Promise<any> => {
  const state = getState();
  const org = state.orgDashboard.gradPrograms.byOrgId[orgId];

  if (!org || force) {
    dispatch(fetchGradProgramRequest(orgId));
    return apiFetchGradProgram(orgId)
      .then(fetchedGradProgram => {
        dispatch(fetchGradProgramSuccess(orgId, fetchedGradProgram));
      })
      .catch(error => {
        if (error.statusCode !== 404) {
          dispatch(setError(error));
        } else {
          // 404 handled by API caller
          throw error;
        }
      });
  }
  return Promise.resolve(org);
};

export const updateGradProgram = fetchGradProgramSuccess;

export const resetGradProgram = () => (dispatch: Dispatch) =>
  dispatch({ type: 'ORG_DASHBOARD_RESET_GRAD_PROGRAMS' });

export const hideGradProgram = ({ orgId }: { orgId: string }) => (
  dispatch: Dispatch
) =>
  apiHideGradProgram({ orgId })
    .then(gradProgram => {
      dispatch(updateGradProgram(orgId, gradProgram));
      dispatch(clearResults());
    })
    .catch(setError);

export const unhideGradProgram = ({
  orgId
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiUnhideGradProgram({ orgId })
    .then(gradProgram => {
      dispatch(updateGradProgram(orgId, gradProgram));
      dispatch(clearResults());
    })
    .catch(setError);
